// extracted by mini-css-extract-plugin
module.exports = {"layoutPadding":"g_p","main":"g_q g_p"};